<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  })
}
</script>

<style>
#app {
  background-color: #ffffff;
  background-image: url("assets/background.svg");
  background-attachment: fixed;
  background-size: cover;
}
</style>
